"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("react-quill/dist/quill.bubble.css");
require("react-quill/dist/quill.snow.css");
require("react-quill/dist/quill.core.css");
require("./InputText.scss");
var _reactQuill = _interopRequireWildcard(require("react-quill"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Parchment = _reactQuill.Quill["import"]("parchment");
var classAttributor = new Parchment.Attributor.Class("class", "class", {
  scope: Parchment.Scope.BLOCK,
  whitelist: ["display", "title", "subtitle", "subheading", "body", "quote", "quote_attribution", "caption_title", "caption", "credit", "overline"]
});
_reactQuill.Quill.register(classAttributor);
var scaleAttributor = new Parchment.Attributor.Class("scale", "scale", {
  scope: Parchment.Scope.BLOCK,
  whitelist: ["primary", "secondary", "extra_large", "large", "medium", "small", "extra_small"]
});
_reactQuill.Quill.register(scaleAttributor);
var CustomToolbar = function CustomToolbar(_ref) {
  var type = _ref.type,
    id = _ref.id,
    onExtendedClick = _ref.onExtendedClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "toolbar-".concat(id),
    className: "ql-toolbar ql-snow"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "default-buttons"
  }, type === "rte-ext-class" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-class"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "display"
  }, "Display"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "title"
  }, "Title"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "subtitle"
  }, "Subtitle"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "subheading"
  }, "Subheading"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "body"
  }, "Body"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "quote"
  }, "Quote"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "quote_attribution"
  }, "Quote Attribution"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "caption_title"
  }, "Caption Title"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "caption"
  }, "Caption"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "credit"
  }, "Credit"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "overline"
  }, "Overline")), /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-scale"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "extra_large"
  }, "Extra Large"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "large"
  }, "Large"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "medium"
  }, "Medium"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "small"
  }, "Small"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "extra_small"
  }, "Extra Small"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "primary"
  }, "Primary"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "secondary"
  }, "Secondary"))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-bold"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-italic"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-underline"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-align"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats extended-button-group group-2"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-list",
    value: "ordered"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-list",
    value: "bullet"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "extended-toggle"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onExtendedClick
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "extended-buttons"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats extended-button-group group-1"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-strike"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-script",
    value: "sub"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-script",
    value: "super"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats extended-button-group group-3"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-indent",
    value: "-1"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-indent",
    value: "+1"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats extended-button-group group-4"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-link",
    value: true
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-clean"
  }))));
};
var QuillRTE = /*#__PURE__*/function (_React$Component) {
  _inherits(QuillRTE, _React$Component);
  var _super = _createSuper(QuillRTE);
  function QuillRTE(props) {
    var _this;
    _classCallCheck(this, QuillRTE);
    _this = _super.call(this, props);
    _this.state = {
      value: props.valueFromInput || props.defaultValue || ""
    };
    _this.extended = false;
    _this.formatclasses = {
      "class": "",
      scale: ""
    };
    _this.quillRef = null;
    _this.preventOnChange = true;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleChangeSelection = _this.handleChangeSelection.bind(_assertThisInitialized(_this));
    _this.handleExtendedClick = _this.handleExtendedClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(QuillRTE, [{
    key: "setFormatClasses",
    value: function setFormatClasses() {
      if (this.quillRef) {
        var toolbarEl = document.querySelector("#toolbar-".concat(this.props.name));
        var fullEditor = this.quillRef.getEditor();
        var format = fullEditor.getFormat();
        if (this.formatclasses["class"] !== "") {
          toolbarEl.classList.remove(this.formatclasses["class"]);
        }
        if (this.formatclasses.scale !== "") {
          toolbarEl.classList.remove(this.formatclasses.scale);
        }
        this.formatclasses["class"] = format["class"] ? "ql-picker-item-class-".concat(format["class"]) : "";
        this.formatclasses.scale = format.scale ? "ql-picker-item-scale-".concat(format.scale) : "";
        if (this.formatclasses["class"] !== "") {
          toolbarEl.classList.add(this.formatclasses["class"]);
        }
        if (this.formatclasses.scale !== "") {
          toolbarEl.classList.add(this.formatclasses.scale);
        }
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(content, delta, source, editor) {
      if (this.state.value !== content && _typeof(this.state.value) !== "object") {
        this.setState({
          value: content
        });
        if (this.quillRef) {
          if (this.props.toolbarType === "rte-ext-class") {
            this.setFormatClasses();
          }
        }
        if (typeof this.props.onChange !== "undefined") {
          this.props.onChange(this.props.name, content);
        }
      }
    }
  }, {
    key: "handleChangeSelection",
    value: function handleChangeSelection(range, source, editor) {
      if (this.props.toolbarType === "rte-ext-class") {
        /*
        Don't try to setFormatClass if the editor doesn't have
        focus, which will be the case if the user clicked in the
        editor and then clicked another control. Without this
        check, focus will be restored to the editor as soon as
        the user clicks another control.
        */
        if (this.quillRef && editor.getSelection()) {
          var fullEditor = this.quillRef.getEditor();
          var tooltipEl = fullEditor.container.querySelector(".ql-tooltip");
          if (tooltipEl.classList.value.includes("ql-hidden")) {
            this.setFormatClasses();
          }
        }
      }
    }
  }, {
    key: "handleExtendedClick",
    value: function handleExtendedClick() {
      var toolbarEl = document.querySelector("#toolbar-".concat(this.props.name));
      if (this.extended) {
        toolbarEl.classList.remove("extended");
      } else {
        toolbarEl.classList.add("extended");
      }
      this.extended = !this.extended;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.quillRef.blur();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.defaultValue !== nextProps.defaultValue) {
        this.setState({
          value: nextProps.defaultValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var modules = {};
      modules.clipboard = {
        matchVisual: false
      };
      var formats = ["bold", "italic", "underline", "strike", "script"];
      var rteClassName = "";
      switch (this.props.toolbarType) {
        case "rte":
          rteClassName = "rte-1";
          modules.toolbar = {
            container: [["bold", "italic", "underline", "strike", {
              script: "sub"
            }, {
              script: "super"
            }, "clean"]]
          };
          break;
        case "rte-ext-class":
          rteClassName = "rte-3";
          modules.toolbar = {
            container: "#toolbar-".concat(this.props.name)
          };
          formats.push("list", "align", "indent", "class", "scale", "link");
          break;
        case "rte-ext":
          rteClassName = "rte-2";
          modules.toolbar = {
            container: "#toolbar-".concat(this.props.name)
          };
          formats.push("list", "align", "indent", "link");
          break;
      }
      if (_reactQuill["default"]) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: this.props.inputStyle,
          className: "cms-input-text rte-container ".concat(rteClassName, " ").concat(this.props.name, " ").concat(this.props.required && (this.state.value === null || this.state.value === undefined || this.state.value === "") ? "invalid-input" : "", " ").concat(this.props.styleName, " ").concat(this.props.theme)
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: "quill-label",
          htmlFor: this.props.name,
          style: this.props.labelStyle
        }, this.props.label), (this.props.toolbarType === "rte-ext" || this.props.toolbarType === "rte-ext-class") && /*#__PURE__*/_react["default"].createElement(CustomToolbar, {
          type: this.props.toolbarType,
          id: this.props.name,
          onExtendedClick: this.handleExtendedClick
        }), /*#__PURE__*/_react["default"].createElement(_reactQuill["default"], {
          ref: function ref(el) {
            return _this2.quillRef = el;
          },
          name: this.props.name,
          modules: modules,
          value: this.state.value,
          onChange: this.handleChange,
          theme: this.props.theme,
          formats: formats,
          onChangeSelection: this.handleChangeSelection,
          bounds: ".cms-input-text.".concat(this.props.name, " .quill")
        }));
      } else {
        // It doesn't appear that this condition is ever met.
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: this.props.inputStyle,
          className: "cms-input-text rte-container ".concat(this.props.required && (this.state.value === null || this.state.value === undefined || this.state.value === "") ? "invalid-input" : "")
        }, /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: param
        }, this.props.label));
      }
    }
  }]);
  return QuillRTE;
}(_react["default"].Component);
QuillRTE.defaultProps = {
  defaultValue: "",
  inputStyle: {},
  labelStyle: {},
  theme: "snow"
};
QuillRTE.propTypes = {
  defaultValue: _propTypes["default"].any,
  styleName: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  inputStyle: _propTypes["default"].object,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].node]),
  labelStyle: _propTypes["default"].object,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string
};
var _default = QuillRTE;
exports["default"] = _default;